(function ($) {
  'use strict';

  $(function () {
    var $form = $('.registration-form');
    if (!$form.length) return;

    var $userTypeInputs = $form.find('input[name="registration_user_type"]');
    var $sections = $form.find('.registration__section[data-show-for]');
    var $userTypeOptions = $form.find('.registration__user-type-option');
    var $conditionalRequired = $form.find('[data-required-for]');
    var $howDidYouHear = $form.find('#how_did_you_hear_about_us');
    var $howDidYouHearOther = $form.find('#how_did_you_hear_about_us_other');
    var $howDidYouHearOtherLabel = $form.find('label[for="how_did_you_hear_about_us_other"]');

    function isOtherHowDidYouHearSelected() {
      if (!$howDidYouHear.length) return false;

      var selectedValue = ($howDidYouHear.val() || '').toString().trim();
      var expectedOtherValue = '7';

      return selectedValue === expectedOtherValue;
    }

    // Section visibility and conditional required fields
    function updateVisibility() {
      var selectedValue = $form.find('input[name="registration_user_type"]:checked').val() || null;

      $userTypeOptions.each(function () {
        var $option = $(this);
        var isChecked = $option.find('input[type="radio"]').is(':checked');
        $option.toggleClass('is-selected', isChecked);
      });

      $sections.each(function () {
        var $section = $(this);
        var showFor = $section.data('showFor').split(',');
        var shouldShow = selectedValue && showFor.includes(selectedValue);
        $section.prop('hidden', !shouldShow);
      });

      $conditionalRequired.each(function () {
        var $field = $(this);
        var requiredFor = $field.data('requiredFor').split(',');
        var isRequired = selectedValue && requiredFor.includes(selectedValue);
        $field.prop('required', isRequired);
      });
    }

    $userTypeInputs.on('change', updateVisibility);
    updateVisibility();

    function toggleHowDidYouHearOther() {
      if (!$howDidYouHear.length || !$howDidYouHearOther.length) return;

      var isOtherSelected = isOtherHowDidYouHearSelected();
      var $otherFieldError = $('#error-how_did_you_hear_about_us_other');

      $howDidYouHearOtherLabel.toggle(isOtherSelected);
      $howDidYouHearOther.toggle(isOtherSelected);
      $otherFieldError.toggle(isOtherSelected);
      $howDidYouHearOther.prop('required', isOtherSelected);

      if (isOtherSelected) {
        $howDidYouHearOther.attr('aria-required', 'true');
      } else {
        clearFieldError($howDidYouHearOther);
        $howDidYouHearOther.removeAttr('aria-required');
      }
    }

    $howDidYouHear.on('change', toggleHowDidYouHearOther);
    toggleHowDidYouHearOther();

    // School autocomplete
    var $schoolSearch = $('#registration_school_search');
    var $schoolId = $('#registration_school');
    var $resultsContainer = $('.registration__school-results');

    if ($schoolSearch.length) {
      var debounceTimer;

      $schoolSearch.on('input', function () {
        var query = $(this).val();

        clearTimeout(debounceTimer);

        if (query.length < 2) {
          $resultsContainer.empty().hide();
          return;
        }

        debounceTimer = setTimeout(function () {
          $.ajax({
            url: chefsInSchoolsAjax,
            data: {
              action: 'cis_search_schools',
              q: query
            },
            success: function (response) {
              if (response.results && response.results.length) {
                var html = response.results.map(function (school) {
                  return '<div class="registration__school-result" data-id="' + school.id + '">' + school.text + '</div>';
                }).join('');
                $resultsContainer.html(html).show();
              } else {
                $resultsContainer.html('<div class="registration__school-no-results">No schools found</div>').show();
              }
            }
          });
        }, 250);
      });

      $resultsContainer.on('click', '.registration__school-result', function () {
        var $result = $(this);
        $schoolSearch.val($result.text());
        $schoolId.val($result.data('id'));
        $resultsContainer.empty().hide();
      });

      $(document).on('click', function (e) {
        if (!$(e.target).closest('.registration__section--school').length) {
          $resultsContainer.hide();
        }
      });
    }

    // Country / Province / Postcode handling
    // Loqate hijacks postcode fields so we use a hidden field for the actual submitted value
    var $country = $('#registration_country');
    var $county = $('#registration_county');
    var $addressFields = $('.registration__address-fields');
    var $postcodeHidden = $('#registration_postcode');
    var $postcodeDisplay = $('#registration_postcode_display');

    // Sync postcode display input from hidden field on load (repopulation after validation error)
    if ($postcodeHidden.val()) {
      $postcodeDisplay.val($postcodeHidden.val());
    }

    // Respect prefers-reduced-motion for slideDown animation
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function revealAddressFields() {
      if ($addressFields.is(':hidden')) {
        prefersReducedMotion ? $addressFields.show() : $addressFields.slideDown(300);
      }
      $('.registration__address-label-auto').hide();
      $('.registration__address-label-manual').show();
      $('.registration__address-manual').hide();
    }

    function loadProvinces(countryId, selectedId) {
      if (!countryId) {
        $county.html('<option value="">Select county</option>').prop('disabled', true);
        return;
      }

      $county.prop('disabled', true).html('<option value="">Loading...</option>');

      $.post(chefsInSchoolsAjax, {
        action: 'cis_get_provinces',
        country_id: countryId
      })
      .done(function (response) {
        if (response.success && response.data.length) {
          var options = response.data.map(function (province) {
            var selected = selectedId && parseInt(selectedId) === province.id ? ' selected' : '';
            return '<option value="' + province.id + '"' + selected + '>' + province.name + '</option>';
          });
          $county
            .prop('disabled', false)
            .html('<option value="">Select county</option>' + options.join(''));
        } else {
          $county.html('<option value="">N/A</option>').prop('disabled', true);
        }
      })
      .fail(function () {
        $county.html('<option value="">Error loading</option>').prop('disabled', true);
      });
    }

    $country.on('change', function () {
      var countryId = $(this).find('option:selected').data('id');
      loadProvinces(countryId, null);
    });

    // Manual address entry link
    $('.registration__address-manual').on('click', function (e) {
      e.preventDefault();
      revealAddressFields();
      $('#registration_address_1').focus();
    });

    // If Loqate not available, reveal fields and swap label immediately
    if (typeof pca === 'undefined') {
      revealAddressFields();
    } else {
      pca.on('load', function (type, id, control) {

        // Disable unwanted Loqate auto-detected controls
        if (type === 'emailvalidation' || type === 'mobilevalidation') {
          control.destroy();
          return;
        }

        // Restrict Loqate to only use address_1 as the search field
        control.fields = [
          { element: 'registration_address_1', field: '', mode: pca.fieldMode.SEARCH }
        ];

        // If address fields already visible on load (repopulation after validation error)
        if ($addressFields.is(':visible')) {
          $('.registration__address-label-auto').hide();
          $('.registration__address-label-manual').show();
          $('.registration__address-manual').hide();

          var countryId = $country.find('option:selected').data('id');
          var selectedCounty = $county.find('option:selected').val();
          if (countryId) {
            loadProvinces(countryId, selectedCounty);
          }
        }

        control.listen('populate', function (address) {
          var company  = address.Company || '';
          var building = address.SubBuilding || address.BuildingName || '';
          var line1    = address.Line1 || '';
          var line2    = address.Line2 || '';

          var parts = [];
          if (company) parts.push(company);
          if (building && building !== line1) parts.push(building);
          if (line1) parts.push(line1);

          $('#registration_address_1').val(parts.join(', '));
          $('#registration_address_2').val(line2);
          $('#registration_city').val(address.City);
          $('#registration_postcode_display').val(address.PostalCode);
          $('#registration_postcode').val(address.PostalCode);

          var $selectedCountry = $country.find('option[value="' + address.CountryIso2 + '"]');

          if ($selectedCountry.length) {
            $country.val(address.CountryIso2);

            var countryId = $selectedCountry.data('id');

            $.post(chefsInSchoolsAjax, {
              action: 'cis_get_provinces',
              country_id: countryId
            })
            .done(function (response) {
              if (response.success && response.data.length) {
                var provinceName = address.Province || address.ProvinceName || '';

                var matched = response.data.find(function (p) {
                  return p.name.toLowerCase() === provinceName.toLowerCase();
                });

                var options = response.data.map(function (p) {
                  return '<option value="' + p.id + '">' + p.name + '</option>';
                });

                $county
                  .prop('disabled', false)
                  .html('<option value="">Select county</option>' + options.join(''));

                if (matched) {
                  $county.val(matched.id);
                }
              } else {
                $county.html('<option value="">N/A</option>').prop('disabled', true);
              }
            })
            .fail(function (xhr) {
              console.error('[Loqate] Province AJAX failed:', xhr);
            });
          }

          revealAddressFields();
        });
      });
    }

    // Helper: add field error with aria attributes
    function addFieldError($field, message, errorId) {
      $field.closest('div').addClass('has-error');
      $field.attr('aria-invalid', 'true');
      if (errorId) {
        $field.attr('aria-describedby', errorId);
      }
      if (!$field.closest('div').find('.field-error').length) {
        var id = errorId ? ' id="' + errorId + '"' : '';
        $field.after('<div class="field-error"' + id + '>' + message + '</div>');
      }
    }

    // Helper: clear field error with aria attributes
    function clearFieldError($field) {
      $field.closest('div').removeClass('has-error');
      $field.removeAttr('aria-invalid');
      $field.removeAttr('aria-describedby');
      $field.closest('div').find('.field-error').remove();
    }

    // Password validation
    var $password = $('#registration_password');
    var $confirmPassword = $('#registration_confirm_password');
    var $passwordError = $('.registration__password-error');
    var $confirmPasswordError = $('.registration__confirm-password-error');

    function validatePassword(password) {
      var errors = [];

      if (password.length < 8) {
        errors.push('at least 8 characters');
      }
      if (!/[a-z]/.test(password)) {
        errors.push('one lowercase letter');
      }
      if (!/[A-Z]/.test(password)) {
        errors.push('one uppercase letter');
      }
      if (!/\d/.test(password)) {
        errors.push('one number');
      }
      if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
        errors.push('one special character');
      }

      return errors;
    }

    function showPasswordErrors() {
      var password = $password.val();
      var confirmPassword = $confirmPassword.val();

      if (password.length > 0) {
        var errors = validatePassword(password);

        if (errors.length > 0) {
          $passwordError.text('Password must contain ' + errors.join(', ')).show();
          $password.closest('.password-container').parent().addClass('has-error');
          $password.attr('aria-invalid', 'true');
        } else {
          $passwordError.hide();
          $password.closest('.password-container').parent().removeClass('has-error');
          $password.removeAttr('aria-invalid');
        }
      }

      if (confirmPassword.length > 0 && password !== confirmPassword) {
        $confirmPasswordError.text('Passwords do not match').show();
        $confirmPassword.closest('.password-container').parent().addClass('has-error');
        $confirmPassword.attr('aria-invalid', 'true');
      } else {
        $confirmPasswordError.hide();
        $confirmPassword.closest('.password-container').parent().removeClass('has-error');
        $confirmPassword.removeAttr('aria-invalid');
      }
    }

    $password.on('blur', showPasswordErrors);
    $confirmPassword.on('blur', showPasswordErrors);

    // GDPR consent
    var $gdprConsent = $('#registration_gdpr_consent');

    // Form submission
    $form.on('submit', function (e) {
      var password         = $password.val();
      var confirmPassword  = $confirmPassword.val();
      var selectedUserType = $form.find('input[name="registration_user_type"]:checked').val();
      var isValid          = true;
	  
	//Fallback to the display postcode if required. If Loqate fails, we want to use the display value
	var $postcodeHidden = $('#registration_postcode');
	var $postcodeDisplay = $('#registration_postcode_display');
	if (!$postcodeHidden.val() && $postcodeDisplay.val()) {
		$postcodeHidden.val($postcodeDisplay.val());
	}

      // Clear all previous client-side errors before revalidating
      $form.find('.field-error').not('.registration__password-error, .registration__confirm-password-error').remove();
      $form.find('.has-error').removeClass('has-error');
      $form.find('[aria-invalid]').removeAttr('aria-invalid');
      $form.find('[aria-describedby]').removeAttr('aria-describedby');

      // First name
      var $firstName = $('#registration_first_name');
      if (!$firstName.val().trim()) {
        addFieldError($firstName, 'First name is required', 'error-registration_first_name');
        isValid = false;
      }

      // Last name
      var $lastName = $('#registration_last_name');
      if (!$lastName.val().trim()) {
        addFieldError($lastName, 'Last name is required', 'error-registration_last_name');
        isValid = false;
      }

      // Email
      var $email = $('#registration_email');
      var emailVal = $email.val().trim();
      if (!emailVal) {
        addFieldError($email, 'Email is required', 'error-registration_email');
        isValid = false;
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal)) {
        addFieldError($email, 'Please enter a valid email address', 'error-registration_email');
        isValid = false;
      }

      // Role
      var $role = $('#registration_role');
      if (!$role.val()) {
        addFieldError($role, 'Please select a role', 'error-registration_role');
        isValid = false;
      }

      // How did you hear about us (other)
      if (isOtherHowDidYouHearSelected() && !$howDidYouHearOther.val().trim()) {
        addFieldError($howDidYouHearOther, 'Please specify how you heard about us', 'error-how_did_you_hear_about_us_other');
        isValid = false;
      }

      // Password complexity
      var passwordErrors = validatePassword(password);
      if (passwordErrors.length > 0) {
        $passwordError.text('Password must contain ' + passwordErrors.join(', ')).show();
        $password.closest('.password-container').parent().addClass('has-error');
        $password.attr('aria-invalid', 'true');
        isValid = false;
      }

      // Password match
      if (password !== confirmPassword) {
        $confirmPasswordError.text('Passwords do not match').show();
        $confirmPassword.closest('.password-container').parent().addClass('has-error');
        $confirmPassword.attr('aria-invalid', 'true');
        isValid = false;
      }

      // School selection (for school_worker)
      if (selectedUserType === 'school_worker' && !$schoolId.val()) {
        addFieldError($schoolSearch, 'Please select a school', 'error-registration_school');
        isValid = false;
      }

      // GDPR consent
      if (!$gdprConsent.is(':checked')) {
        $gdprConsent.closest('div').addClass('has-error');
        $gdprConsent.attr('aria-invalid', 'true');
        if (!$gdprConsent.closest('div').find('.field-error').length) {
          $gdprConsent.attr('aria-describedby', 'error-registration_gdpr_consent');
          $gdprConsent.closest('label').after('<div class="field-error" id="error-registration_gdpr_consent">You must consent to the privacy policy to register</div>');
        }
        isValid = false;
      }

      if (!isValid) {
        e.preventDefault();
        var $firstError = $form.find('.has-error').first();
        if ($firstError.length) {
          $('html, body').animate({
            scrollTop: $firstError.offset().top - 100
          }, 300);
        }
      }
    });
  });
})(jQuery);